import * as Yup from "yup"
import i18next from "i18next"

export const SosSendSchema = Yup.object({
    description: Yup.string().notRequired(),
})

export const GuardSosSchema = Yup.object({
    description: Yup.string().trim().required(i18next.t('sos.error_description')),
    ticket_file: Yup.array().max(10, i18next.t('sos.error_max_files')).notRequired(),
})

export const EmergencyContactSchema = Yup.object({
    name: Yup.string().trim().required(i18next.t('sos.error_name')),
    mobile_number: Yup.string()
        .matches(/^[0-9]+$/, i18next.t('sos.error_invalid_mobile'))
        .required(i18next.t('sos.error_mobile_number')),
})